import React from 'react';
import { useForm } from "react-hook-form";
import { InputLabel } from '@material-ui/core';
import { Link } from 'react-router-dom';


const SignIn = () => {

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => console.log(data);
    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <InputLabel htmlFor="email" style={{color:'black'}}>Email</InputLabel>
                <input placeholder="Email Address" type="email" name="emailRequired" ref={register({ required: true })} />
                {errors.emailRequired && <span className="text-danger">Email is required</span>}
                <br />
                <br />
                <InputLabel htmlFor="password" style={{color:'black'}}>Password</InputLabel>
                <input placeholder="Password" type="password" name="passwordRequired" ref={register({ required: true })} />
                {errors.passwordRequired && <span className="text-danger" style={{color:'black'}}>Password is required</span>}
                <br />
                <input className="btn btn-primary mt-3" type="submit" value="Log In" />
                <p style={{color:'black'}}>Don’t have an account? <Link className="text-warning text-decoration-none"  to="/register"> <span style={{color:'green'}}>Create an account</span> </Link></p>
            </form>
        </div>
    );
};

export default SignIn;